export const versionDetailsStyles = {
  compactPaper: {
    padding: "1rem 1.25rem",
    marginBottom: "1.5rem",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    border: "1px solid #e5e7eb",
    backgroundColor: "#ffffff",
  },
  compactHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
    flexWrap: "wrap",
  },
  compactTitle: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#111827",
    lineHeight: 1.3,
    flex: 1,
    minWidth: "200px",
  },
  infoRow: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    flexWrap: "wrap",
  },
  subjectRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "0.5rem",
    flexWrap: "wrap",
  },
  buttonRow: {
    display: "flex",
    alignItems: "center",
    marginTop: "0.25rem",
  },
  infoItem: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    flexWrap: "wrap",
  },
  infoLabel: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#6b7280",
    minWidth: "80px",
  },
  infoValue: {
    fontSize: "14px",
    color: "#111827",
    fontWeight: 400,
  },
  compactPaper: {
    padding: "1rem 1.25rem",
    marginBottom: "1.5rem",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    border: "1px solid #e5e7eb",
    backgroundColor: "#ffffff",
  },
  compactHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
    flexWrap: "wrap",
  },
  compactTitle: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#111827",
    lineHeight: 1.3,
    flex: 1,
    minWidth: "200px",
  },
  infoRow: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    flexWrap: "wrap",
  },
  subjectRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "0.5rem",
    flexWrap: "wrap",
  },
  buttonRow: {
    display: "flex",
    alignItems: "center",
    marginTop: "0.25rem",
  },
  infoItem: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    flexWrap: "wrap",
  },
  infoLabel: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#6b7280",
    whiteSpace: "nowrap",
  },
  infoValue: {
    fontSize: "14px",
    color: "#111827",
    fontWeight: 400,
  },
  subjectBox: {
    marginTop: "1rem",
    padding: "0.75rem 0",
  },
  subjectLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#6b7280",
    marginBottom: "0.25rem",
  },
  subjectText: {
    fontSize: "16px",
    color: "#111827",
  },
  senderBox: {
    marginTop: "0.5rem",
    padding: "0.75rem 0",
  },
  senderLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#6b7280",
    marginBottom: "0.25rem",
  },
  senderText: {
    fontSize: "16px",
    color: "#111827",
    fontWeight: 500,
  },
  tabsContainer: {
    marginTop: "1.5rem",
    borderBottom: "1px solid #e5e7eb",
  },
  tabs: {
    "& .MuiTabs-indicator": {
      backgroundColor: "#367598",
    },
  },
  tab: {
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 500,
    minHeight: "48px",
    padding: "0 16px",
  },
  tableContainer: {
    marginTop: "1.5rem",
  },
  loaderBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
  },
  emptyStatePaper: {
    padding: "3rem",
    textAlign: "center",
    backgroundColor: "#f9fafb",
    borderRadius: "8px",
  },
  emptyStateText: {
    fontSize: "16px",
    color: "#6b7280",
  },
  notFoundBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "400px",
    padding: "2rem",
  },
  notFoundTitle: {
    fontSize: "24px",
    fontWeight: 600,
    color: "#111827",
    marginBottom: "0.5rem",
  },
  notFoundBody: {
    fontSize: "16px",
    color: "#6b7280",
  },
  actionButtonBox: {
    marginTop: "1rem",
    padding: "0.75rem 0",
  },
  viewSuppressionButton: {
    textTransform: "none",
    fontSize: "13px",
    padding: "6px 14px",
    color: "#367598",
    borderColor: "#367598",
    whiteSpace: "nowrap",
    "&:hover": {
      borderColor: "#2c5f7a",
      backgroundColor: "rgba(54, 117, 152, 0.04)",
    },
  },
  senderEmailsList: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    flexWrap: "wrap",
  },
  senderEmailChip: {
    backgroundColor: "#f0f9ff",
    color: "#0369a1",
    fontSize: "0.8125rem",
    fontWeight: 500,
    height: "24px",
    borderRadius: "6px",
    border: "1px solid #bae6fd",
    "& .MuiChip-label": {
      padding: "0 8px",
      fontFamily: "monospace",
    },
  },
};
